<template>
    <div>
        <!-- <h2>Business Sector</h2>
         <b-button variant="outline-primary" v-b-modal.AddBusinessSctor>
            <b-icon icon="plus-circle-fill"  scale="1" variant="success"></b-icon>
            Add Business Sector
        </b-button> -->

        <v-btn   color="primary" class="ma-2 white--text"  @click="showAddBusinessSector">
            Add Business Sector <v-icon right dark> mdi-plus</v-icon>
        </v-btn>

         <v-container color="primary">
              <v-card
                    icon="clipboard-text"
                    title="Business Sector"
                    class="px-5 py-10">
                     <v-card-title>
                          <v-row>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details>
                            </v-text-field>
                        </v-row>
                        <v-row>
                            <v-progress-linear
                                :active="loading"
                                color="green"
                                :indeterminate="loading"
                                absolute
                                bottom
                                height="15">
                                Loading...
                            </v-progress-linear>`
                        </v-row>
                     </v-card-title>
                       <v-data-table
                        dense
                        :headers="fields"
                        :items="items"
                        :search="search"
                        class="elevation-1">
                            <template  v-slot:[`header.id`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                            <template  v-slot:[`header.industryTypeName`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                            <template  v-slot:[`header.englishName`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                             <template  v-slot:[`header.arabicName`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>
                             <template  v-slot:[`header.Action`]="{ header }">
                                <h6><b> {{ header.text}}</b> </h6>
                            </template>

                            <template v-slot:top>
                                  <v-dialog
                                    v-model="Editdialog"
                                    max-width="800px">
                                        <v-card>
                                             <v-card-title>
                                                <span class="text-h5">Edit Business Sector</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-form ref="form" v-model="valid" lazy-validation>
                                                     <v-container>
                                                         <v-row>
                                                            <v-col cols="12" sm="6" md="6">
                                                                 <v-select
                                                                    v-model="editedItem.industryTypeId"
                                                                    :items="options"
                                                                    :rules="[rules.required]"
                                                                    label="Industry Type"
                                                                    required
                                                                    ></v-select>
                                                            </v-col>
                                                         </v-row>
                                                          <v-row>
                                                            <v-col cols="12" sm="6" md="6">
                                                                 <v-text-field
                                                                    v-model="editedItem.englishName"
                                                                    :rules="[rules.required]"
                                                                    required
                                                                    label="English Name">
                                                                </v-text-field>
                                                            </v-col>
                                                         </v-row>
                                                         <v-row>
                                                            <v-col cols="12" sm="6" md="6">
                                                                 <v-text-field
                                                                    v-model="editedItem.arabicName"
                                                                    :rules="[rules.required]"
                                                                    required
                                                                    label="Arabic Name">
                                                                </v-text-field>
                                                            </v-col>
                                                         </v-row>
                                                     </v-container>
                                                </v-form>
                                            </v-card-text>
                                             <v-card-actions>
                                                <v-spacer></v-spacer>
                                                 <v-btn color="green darken-1" text @click="close"> Cancel</v-btn>
                                                 <v-btn color="green darken-1" :disabled="!valid" text @click="validate" >Save</v-btn>
                                             </v-card-actions>
                                        </v-card>
                                  </v-dialog>
                            </template>

                              <template v-slot:[`item.Action`]="{ item }">
                                    <v-icon small class="mr-2"  @click="editItem(item)" >
                                        mdi-pencil
                                    </v-icon>
                                     <v-icon small class="mr-2"  @click="approveRequestConfirm(item)" color="red" v-if="item.status==0" >
                                        mdi-brightness-1
                                    </v-icon>
                                     <v-icon small class="mr-2"  @click="approveRequestConfirm(item)" color="green" v-if="item.status==1" >
                                        mdi-brightness-1
                                    </v-icon>
                                     <v-icon small class="mr-2"  @click="approveDeleteConfirm(item)" color="red"  >
                                        mdi-delete-empty
                                    </v-icon>
                                </template>
                       </v-data-table>
              </v-card>
         </v-container>

          <v-dialog
        v-model="addBusinessSectorDialog"
        max-width="800px">
            <v-card>
                 <v-card-title>
                    <span class="text-h5">Add Business Sector</span>
                </v-card-title>
                 <v-card-text>
                      <v-form ref="Addform" v-model="valid" lazy-validation>
                           <v-container>
                                <v-row>
                                     <v-col cols="12" sm="6" md="6">
                                            <v-select
                                            v-model="editedItem.industryTypeId"
                                            :items="options"
                                            :rules="[rules.required]"
                                            label="Industry Type"
                                            required
                                            ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                            <v-text-field
                                            v-model="editedItem.englishName"
                                            :rules="[rules.required]"
                                            required
                                            label="English Name">
                                        </v-text-field>
                                    </v-col>
                                    </v-row>
                                    <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                            <v-text-field
                                            v-model="editedItem.arabicName"
                                            :rules="[rules.required]"
                                            required
                                            label="Arabic Name">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                           </v-container>
                      </v-form>
                 </v-card-text>
                 <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="close"> Cancel</v-btn>
                    <v-btn color="green darken-1" :disabled="!valid" text @click="validateNew" >Save</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>


        <v-dialog v-model="approveReqDialog" max-width="500px">
                <v-card
                :loading = loading loading-text="Loading... Please wait">
                    <v-card-title class="text-h3">Are you sure ? </v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="updateTypeStatus">Yes</v-btn>
                    <v-btn color="green darken-1" text @click="closeApprove">No</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDeleteDialog" max-width="500px">
                <v-card
                :loading = loading loading-text="Loading... Please wait">
                    <v-card-title class="text-h3">Are you sure ? </v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="deleteBusinessSector">Yes</v-btn>
                    <v-btn color="green darken-1" text @click="confirmDeleteDialog = false">No</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>


          <div class="text-center">
                <v-snackbar v-model="snackbar" timeout="3000">
                    {{ alertMsg }}
                    <template v-slot:action="{ attrs }">
                        <v-btn
                            color="green"
                            text
                            v-bind="attrs"
                            @click="snackbar = false">
                            Close
                        </v-btn>
                    </template>
            </v-snackbar>
        </div>


    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
    mixins: [validationMixin],
    data(){
        return{
            confirmDeleteDialog:false,
            approveReqDialog:false,
            addBusinessSectorDialog:false,
            editedIndex:-1,
             editedItem: {
                id:-1,
                industryType:-1,
                arabicName: '',
                englishName:'',
                status:-1,
            },
             alertMsg:'',
            snackbar:false,
            Editdialog:false,
            search:'',
            loading:false,
            rules: {
                required: value => !!value || 'Required Field',
            },
            fields: [
                    {value:'id', text:'id'},
                    {value:'industryTypeName',text:'Industry Type'},
                    {value:'englishName', text:'English Name'},
                    {value:'arabicName',text:'Arabic Name'},
                    {value:"Action", text:"Action"}
                ],
            items: [],
            options: [],
            selected: null,
             form: {
                englishName: null,
                arabicName:null,
                industryType:null,
                id:null
            },
            currentEditedType:null
        }
    },
    validations: {
        form: {
            englishName: {
                required,
                minLength: minLength(3)
            },
            arabicName: {
                required,
                minLength: minLength(3)
            },
            industryType:{
                required
            }
        }
    },
    methods:{
        approveDeleteConfirm(item){
            if(Boolean(item.hasChildren) == false){
                 this.editedItem = item;
                this.editedIndex = this.items.indexOf(item)
                this.confirmDeleteDialog = true
            }
            else{
                this.alertMsg = "Business Sector cannot be deleted, it has business Sub-sectors"
                this.snackbar = true;
            }
        },
        close () {
            this.Editdialog = false
            this.addIndustryTypeDialog = false;
            this.$nextTick(() => {
                this.clear();
            })
        },
         validate () {
            if(this.$refs.form.validate())
            {
                this.UpdateBusinessSector();
            }
         },
          validateNew(){
              if(this.$refs.Addform.validate())
            {
                this.addBusinessSector();
            }
         },
        clear(){
            this.editedIndex = -1;
            this.editedItem.id = -1;
            this.editedItem.industryType = -1;
            this.editedItem.arabicName = '';
            this.editedItem.englishName = '';
            this.editedItem.status = -1;
        },
        closeApprove(){
            this.approveReqDialog = false;
            this.clear();
        },
        updateTypeStatus(){
            let status = -1;
            this.editedItem.status == 1 ? status = 0 : status = 1;
            this.$axios({
                    method: 'put',
                    url: `${this.$baseURL}/BusinessSector/status?Sector=${this.editedItem.id}&Status=${status}`,
                }).then(()=>{
                    this.approveReqDialog = false;
                    this.$nextTick(() => {
                                    this.items[this.editedIndex].status = status;
                                    this.alertMsg = "Business Sector updated successfully"
                                    this.snackbar = true;
                                    this.loading = false;
                             })
                });
        },
        approveRequestConfirm(item){
            this.editedItem = item;
            this.editedIndex = this.items.indexOf(item)
            this.approveReqDialog = true;
        },
        updateSectorStatus(item,index,activate){
             if(activate == 1 && item.status == 1){
                this.$bvModal.msgBoxOk('Business Sector is already Active', {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                        })
                        return;
            }
            if(activate == 0 && item.status == 0){
                this.$bvModal.msgBoxOk('Business Sector is already InActive', {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                        })
                        return;
            }
            this.$axios({
                    method: 'put',
                    url: `${this.$baseURL}/BusinessSector/status?Id=${item.id}&Status=${activate}`,
                }).then(()=>{
                        this.items[index].status = activate;
                        this.$refs.SectorsList.refresh();
                });

        },
        getVariant(item,activateSector){
            if(Boolean(activateSector) == true){
                if(item.status == 1)
                    return 'primary'
                else
                    return 'secondary'
            }
            else{
                if(item.status == 1)
                    return 'secondary'
                else
                    return 'primary'
            }

        },
        editItem (item) {
            this.clear();
            this.getIndustryTypeOptions();
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.Editdialog = true
        },
        getIndustryTypeOptions(){
              this.$axios({
                method: 'get',
                url: `${this.$baseURL}/IndustryType/active`,
            })
            .then((response)=>{
               this.options = response.data.map(val=>({
                    value:val.id,
                    text:val.englishName
                })
                );
            });
         },
         showAddBusinessSector(){
            if(this.options.length == 0){
                this.getIndustryTypeOptions();
            }
           this.clear();
           this.addBusinessSectorDialog = true;
        },
        addBusinessSector(){
             this.$axios({
                    method: 'post',
                    url: `${this.$baseURL}/BusinessSector`,
                    data: {
                        EnglishName: this.editedItem.englishName,
                        ArabicName: this.editedItem.arabicName,
                        IndustryTypeId:this.editedItem.industryTypeId
                    }
                }).then((response)=>{

                    this.$nextTick(() => {
                         this.$nextTick(() => {
                                this.addBusinessSectorDialog = false;
                                this.items = response.data;
                                this.close()
                                this.alertMsg = "Business Sector added successfully"
                                this.snackbar = true;
                            });
                    });



                });

        },
         editBusinessSector(item,index){
              if(this.options.length == 0){
                this.getIndustryTypeOptions();
            }
             this.$nextTick(() => {
                this.form.industryType =
                this.options.filter(o=>o.englishName ==  item.industryTypeName)[0].id
                this.form.englishName = item.englishName;
                this.form.arabicName = item.arabicName;
                this.form.id = item.id;

                this.$bvModal.show('EditBusinessSector');
                this.currentEditedSector = index;
            });

        },
        UpdateBusinessSector(){
            this.$axios({
                    method: 'put',
                    url: `${this.$baseURL}/BusinessSector`,
                    data: {
                        EnglishName: this.editedItem.englishName,
                        ArabicName: this.editedItem.arabicName,
                        IndustryTypeId:this.editedItem.industryTypeId,
                        id:this.editedItem.id
                    }
                }).then((response)=>{
                    if(response.data == true)
                    {
                        Object.assign(this.items[this.editedIndex], this.editedItem)
                        this.close()
                        this.alertMsg = "Business Sector updated successfully"
                        this.snackbar = true;
                    }
                });
        },
        deleteBusinessSector(){
              this.$axios({
                    method: 'delete',
                    url: `${this.$baseURL}/BusinessSector`,
                    data: {Id:this.editedItem.id}
                    }).then(()=>{
                         this.items .splice(this.editedIndex , 1);
                        this.confirmDeleteDialog = false;
                    });
        },
        onReset(){
            this.form ={
                englishName: null,
                arabicName:null,
                industryType:null
            };
             this.$nextTick(() => {
                this.$v.$reset();
            });
        },
          validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
    },
     mounted(){
        this.$axios({
                method: 'get',
                url: `${this.$baseURL}/BusinessSector`,
            })
            .then((response)=>{
                this.items = response.data;
            });
    }
}
</script>

<style>

</style>